import type { AsyncDataOptions } from '#app'

export function useAppAsyncData<DataT>(
  key: string,
  handler: () => Promise<DataT>,
  options?: AsyncDataOptions<DataT>,
) {
  const localError = ref<Error | null>(null)

  const asyncData = useAsyncData(
    key,
    async () => {
      try {
        localError.value = null
        return await handler()
      } catch (error) {
        localError.value =
          error instanceof Error ? error : new Error(String(error))
        console.warn(`Ошибка загрузки данных (${key}):`, localError.value)
        return null as unknown as DataT
      }
    },
    {
      server: !import.meta.dev,
      ...options,
    },
  )

  return {
    ...asyncData,
    error: localError,
  }
}
